
import {Router} from "@angular/router";
import {JwtHelperService} from "@auth0/angular-jwt";
import {Jwt, Token, Tenant} from "@core/types";
import { Injectable, inject } from "@angular/core";
import { profileStore } from "@core/store";


@Injectable({
  providedIn: 'root',
})
export class  SecurityService {

   private store = inject(profileStore);

  constructor(private router: Router,
              private jwtHelper: JwtHelperService,) {
  }


  // Método para actualizar token y tenant sin navegar (usado en cambio de tenant)
  updateTokenAndTenant(token: Token): void {
    this.store.setToken(token);
    let jwt = this.jwtHelper.decodeToken(token.value) as Jwt;
    
    // Deserializar tenants desde JSON
    let tenants: Tenant[] = [];
    if (jwt.tenants) {
      tenants = JSON.parse(jwt.tenants) as Tenant[];
    }
    
    this.store.setUserInfo(
      jwt.email, // userName no está en JWT, usar email
      jwt.email,
      jwt.name,
      jwt.lastName,
      "",
      jwt.defaultTenant,
      tenants
    );

    if (jwt.role) {
      this.store.setRole(jwt.role);
    }
    if (jwt.activeCondominium) {
      this.store.setActiveCondominium(jwt.activeCondominium);
    }
    // NO navegar - el usuario ya está en una ruta válida
  }

  // Método para login inicial (actualiza token y navega)
  setAuthentication(token: Token): void {
    this.updateTokenAndTenant(token);
    this.router.navigate(['/']); // Solo navegar en login inicial
  }

  switchTenant(tenantId: string): void {
    // Solo actualizar el tenant activo en el store
    // El backend validará el tenant automáticamente en cada request mediante el header X-Tenant-Id
    this.store.setActiveTenant(tenantId);
  }


  logout(): void {
    this.store.clearProfile();
    this.router.navigate(['/auth/login']);
  }


}
